import reduceReducers from 'reduce-reducers';

import onlineServiceReducer from './onlineService-reducer';
import storePersistReducer from './store-persist-reducer';

export default reduceReducers(onlineServiceReducer, storePersistReducer);
